import Checkout from "../order/Checkout";
import { Link } from "react-router-dom";
import React from "react";
import Footer from "../components/Footer";
import Header from "../components/Header";
import MetaComponent from "../components/MetaComponent";
// import Hero from "./home/Hero";




const metadata = {
    title: `Checkout || ${process.env.REACT_APP_META_TITLE}`,
    description: process.env.REACT_APP_META_DESCRIPTION,
};

export default function CheckoutPage({ onPageReady }) {
    return (
        <>
            <MetaComponent meta={metadata} />
            <Header />
            <>
                {/* Breadcrumb */}
                <div className="tf-breadcrumb">
                    <div className="container">
                        <ul className="breadcrumb-list">
                            <li className="item-breadcrumb">
                                <Link to={`/`} className="text">
                                    Home
                                </Link>
                            </li>
                            <li className="item-breadcrumb dot">
                                <span />
                            </li>
                            <li className="item-breadcrumb">
                                <span className="text">Checkout</span>
                            </li>
                        </ul>
                    </div>
                </div>
                {/* /Breadcrumb */}
                {/* Title Page */}
                <section className="page-title">
                    <div className="container">
                        <div className="box-title text-center justify-items-center">
                            <h4 className="title">Checkout</h4>
                        </div>
                    </div>
                </section>
                {/* /Title Page */}
            </>
            <Checkout onLoaded={() => onPageReady?.()}/>
            <Footer />
        </>
    );
}
